/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-13 12:39:21
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-24 15:00:26
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelPreviewPageComponents/SectionContainer/index.tsx
 */
import React from 'react';
import css from './css.less';
import { ErrorBoundary } from 'src/components/ErrorBoundary';

const Section = (props) => {
  const { children, className, bottomBorder, style } = props;
  return (
    <div
      style={style}
      className={`${css.container} ${bottomBorder ? css.bottomBorder : ''} ${
        className || ''
      }`}>
      <ErrorBoundary>{children}</ErrorBoundary>
    </div>
  );
};
export default Section;
